export default {
    name: 'calendar_item_with_performance_code_participation',
    definition: {
        business_data_id: '',
        calendar_item_id: '',
        indication_history_id: '',
        patient_id: '',
        send_confirmation: '',
        send_reminder: '',
        confirmation_template_id: '',
        reminder_template_id: '',
        indication_history: {
            jsonApi: 'hasOne',
            type: 'indication_history',
        },
        patient: {
            jsonApi: 'hasOne',
            type: 'patient',
        },
        chronic: '',
        complaint: '',
        date_of_birth: '',
        date_of_indication: '',
        description: '',
        diagnosis_code: '',
        gender: '',
        general_practitioner: '',
        identification_number: '',
        indication: '',
        indication_code: '',
        insurance_details: '',
        invoice_can_be_printed: '',
        invoicing_profile: '',
        module: '',
        paid_by: '',
        participation_date: '',
        patient_address_phone_mobile: '',
        patient_address_phone_private: '',
        patient_age: '',
        patient_name: '',
        patient_policy_item_id: '',
        performance_code: '',
        photo_id: '',
        private_invoicing_details: '',
        reasons: '',
        referrer: '',
        status: '',
        therapist: '',
        total_amount: '',

    },
    options: {
        collectionPath: 'participation_payment_status',
    },
};
